export default "__VITE_ASSET__BtYl1SVB__"